import styled from 'styled-components'
import imgHome from '../../../assets/images/home/xgreen_bgEXTRAClean-2@2x.png'

export const Container = styled.div`
  /* box-sizing: border-box; */
  min-height: 100vh !important;
  min-width: 100vw;
  background-image: url(${imgHome});
  background-size: cover;
  background-repeat: no-repeat;
  @media screen and (max-width: 768px) {
    background-size: cover;
    background-position: center;
  }
`

export const Grid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  grid-gap: 5px;
  min-height: 100vh;
  width: 100%;
  align-items: center;
  @media screen and (max-width: 1050px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
`
export const DivText = styled.div`
  margin-right: 20%;
  @media screen and (max-width: 800px) {
    padding: 0px 12px 0px 12px;
    margin: 0px;
  }
`
export const Wrapper = styled.div`
  p:nth-of-type(1) {
    max-width: 542px;
    font-size: 45px;
    font-family: 'avenir_nextbold';
    line-height: 50px;
    color: #fff;
  }

  p:nth-of-type(2) {
    max-width: 542px;
    font-family: 'avenir_nextregular';
    font-size: 20px;
    text-align: left;
    line-height: 26px;
    color: #fff;
  }

  button:nth-of-type(1) {
    width: 430px;
    justify-content: center;
    background-color: #9dfdca;
    border: transparent;
    height: 65px;
    color: #000;
    font-size: 26px;
    font-family: 'avenir_nextbold';
  }

  button:nth-of-type(2) {
    width: 430px;
    border-radius: 15px;
    justify-content: center;
    background-color: #fff;
    height: 65px;
    color: #000;
    font-size: 26px;
    font-family: 'avenir_nextbold';
    border: none;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
    padding: 5% 3% 0 0;

    button {
      width: 95% !important;
      margin-right: 12px;
    }

    p:nth-of-type(1) {
      max-width: 366px;
      font-size: 26px;
      font-family: 'avenir_nextbold';
      line-height: 31px;
    }
    p:nth-of-type(2) {
      max-width: 366px;
      font-family: 'avenir_nextregular';
      font-size: 16px;
    }
    button {
      font-size: 16px !important;
      width: 95% !important;
    }
  }
`

export const DivImg = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 800px) {
    img {
      width: 100%;
    }
  }
`
